import React from 'react';
import { ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';

const StyledLoadView = styled.View<{
  modal?: boolean;
  backgroundColor?: string;
}>`
  flex: 1;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${p =>
    p.backgroundColor
      ? p.backgroundColor
      : p.modal
      ? 'rgba(255, 255, 255, 0.1)'
      : '#fff'};
  position: ${p => (p.modal ? 'absolute' : 'relative')};
  top: 0;
  left: 0;
`;

const ActivityIndicatorScreen: React.FC<{
  /**
   * Set the color of the activity indicator
   */
  color?: string;
  /**
   * Determine if the view should be absolute positioned over the current
   * content
   */
  modal?: boolean;
  /**
   * Set the background color of the activity indicator
   */
  backgroundColor?: string;
}> = ({ color = '#999', modal, backgroundColor }) => {
  return (
    <StyledLoadView modal={modal} backgroundColor={backgroundColor}>
      <ActivityIndicator color={color} size='large' />
    </StyledLoadView>
  );
};

export default ActivityIndicatorScreen;
